// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"1126":"bd16a9bf","2375":"bd16a9bf","2642":"bd16a9bf"}[chunkId] + ".chunk.css");